// @flow
import React, {Component} from 'react';
import {FormattedMessage} from 'react-intl';
import {compose} from 'redux';
import {connect} from 'react-redux';
import cookieUtils from '../../utils/cookieUtils';
import {trigger as edapTrigger} from '../../utils/edapWrapper';
import {LOCATION_COOKIE} from '../../utils/locationData';
import {tripQueryFromTripCookie, TRIPDATA_COOKIE} from '../../utils/tripData';
import {canonicalizeSearchRequest} from '../../utils/searchParamsUtils';

import type {State as ReduxState} from '../../reducers';

import './FallbackComponent.less';
import {toSERPURL} from '../../utils/urlUtils';

type Props = {
    siteName: string
};

// TODO: replace with the 404 page from SERP-343
export class FallbackComponent extends Component<Props> {
    componentDidMount() {
        this.didHaveError();
    }

    buildRedirectUrl = () => {
        const {siteName} = this.props;
        const locationCookie = cookieUtils.readCookie(LOCATION_COOKIE);
        const tripCookie = tripQueryFromTripCookie(
            cookieUtils.readCookie(TRIPDATA_COOKIE)
        );
        const searchRequest = canonicalizeSearchRequest({
            ...tripCookie,
            q: locationCookie.lbsKeywords
        });

        return toSERPURL(searchRequest, {siteName});
    };

    didHaveError = () => {
        edapTrigger('generic.error', {
            logmessage: 'oops',
            highfrequency: 'true'
        });
    };

    render() {
        return (
            <div className="FallbackComponent" data-wdio="FallbackComponent">
                <div className="FallbackComponent__message">
                    <FormattedMessage tagName="h3" id="tempOopsMessage" />
                </div>

                <div className="FallbackComponent__redirect-message">
                    <a
                        href={`${this.buildRedirectUrl()}`}
                        data-wdio="FallbackComponent_link"
                    >
                        <FormattedMessage id="tempOopsRedirect" />
                    </a>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: ReduxState): Props => ({
    siteName: state.system.siteName
});

export default compose(connect(mapStateToProps))(FallbackComponent);
